export const defaultLabels = {
  login: `Per poter acquistare tramite e-commerce è necessario eseguire il login all'area riservata del sito.`,
  registrati: `Per accedere la prima volta è necessario registrarsi.  I dati forniti saranno utilizzati nel rispetto della
  privacy.`,
  test: "questo è un test",
};
